import { Directive, HostListener, Input } from "@angular/core";
@Directive({
    selector: "[tabOrder]"
})
export class TabOrderDirective {
    @Input() tabFrom: string;
    @Input() tabTo: string;

    @HostListener("keydown", ["$event"]) 
    onKeyDown(e):void {
        // When Press Shift + Tab
        if (e.shiftKey && e.keyCode === 9 || e.keyCode === 37) {
            const navigateFrom: any = document.getElementById(this.tabFrom);
            if (navigateFrom) {
                e.preventDefault();
                navigateFrom.focus();
            } // When Press Tab
        } else if (e.keyCode === 9 || e.keyCode === 39) {
            const navigateTo: any = document.getElementById(this.tabTo);
            if (navigateTo) {
                e.preventDefault();
                navigateTo.focus();
            }
        }
    }
}
